// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__13ZLQ","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1hfUl"};